module.exports = __webpack_public_path__ + "img/3-2-2.db9880d0.png";